import styled from 'styled-components';

export const OnboardingBlock = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  text-align: center;
  padding: 20px;
  background: #0b0b0b;

  .brand_logo {
    display: block;
    width: max-content;
    margin: 0 auto 25px;
    font-family: 'Lora', 'Georgia', serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.02em;
    color: var(--white);

    @media (min-width: 992px) {
      position: absolute;
      left: 20px;
      top: 20px;
      margin: 0;
    }
  }
`;

export const FormCol = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .form-content {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
  }
`;
